// ==========================================================================
// Tabs initializer / controller singleton
// ==========================================================================

class Tabs {
  constructor() {
    this.init = this.init.bind(this);
  }

  init() {
    this.controls = [...document.querySelectorAll('.js-tab-control')];
    this.targets = [...document.querySelectorAll('.js-tab-target')];
    if (this.controls) {
      this.controls.map(control => {
        if (control.value !== 'initialized') {
          control.value = 'initialized';
          this._bindTabs(control);
        }
      });
    }
  }

  _bindTabs(control) {
    control.addEventListener('click', event => {
      event.preventDefault();
      const target = document.querySelector(control.getAttribute('href'));

      if (!control.matches('.tab-open')) {
        this.controls.map(control => {
          control.classList.remove('tab-open');
        });
        this.targets.map(target => {
          target.classList.remove('tab-open');
        });
        control.classList.add('tab-open');
        target.classList.add('tab-open');
      }
    });
  }
}

export default new Tabs();



// WEBPACK FOOTER //
// ./src/js/tabs.js